import { render, staticRenderFns } from "./btn.vue?vue&type=template&id=331e3d67&scoped=true"
import script from "./btn.vue?vue&type=script&lang=ts"
export * from "./btn.vue?vue&type=script&lang=ts"
import style0 from "./btn.vue?vue&type=style&index=0&id=331e3d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e3d67",
  null
  
)

export default component.exports